import insertAfter from '../../../general/insertAfter';

import createTableWrapper from './createTableWrapper';

// ----------------------------------------------------------------------------

function alreadyTableWrapper(element: HTMLElement, config: Record<string, any> = {}): HTMLElement {
    let elTableWrapper = element.closest('.table-wrapper') as HTMLElement | undefined;

    if (!elTableWrapper) {
        elTableWrapper = createTableWrapper(config);

        if (element.parentNode) {
            insertAfter(elTableWrapper, element);
        }

        elTableWrapper.appendChild(element);
    }

    return elTableWrapper;
}

// ----------------------------------------------------------------------------

export default alreadyTableWrapper;
